var _defs, _rect, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgentTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "at-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0F766E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#134E4A"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "url(#at-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 28,
    width: 80,
    height: 104,
    rx: 8,
    fill: "#ffffff",
    opacity: 0.96
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 45,
    x2: 108,
    y2: 45,
    stroke: "#0F766E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 57,
    x2: 96,
    y2: 57,
    stroke: "#0F766E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 69,
    x2: 104,
    y2: 69,
    stroke: "#0F766E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 99,
    x2: 100,
    y2: 99,
    stroke: "#0F766E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 111,
    x2: 92,
    y2: 111,
    stroke: "#0F766E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 84,
    x2: 134,
    y2: 84,
    stroke: "#FBBF24",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "10 8"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "134,75 143,84 134,93",
    fill: "none",
    stroke: "#FBBF24",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentTerms);
export default __webpack_public_path__ + "static/media/AgentTerms.03226225d0e0c43413806b7782265727.svg";
export { ForwardRef as ReactComponent };